import { render, staticRenderFns } from "./cModalService.vue?vue&type=template&id=bdfcbb58"
import script from "./cModalService.vue?vue&type=script&lang=js"
export * from "./cModalService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports